import React from "react";
import AdjustmentDetailsModal from "./AdjustmentDetailsModal";
import { useModal } from "../../../../../contexts/customModal";
const underLineStyle = { borderBottom: "1px solid #00B0F5" };

const ViewAdjustmentsButton = ({ applicationId, groupedData,transferInBU, transferOutBU }) => {
  const { showModal } = useModal();

  return (
    <div className="btn btn-link link-underline-primary">
      <span
        style={underLineStyle}
        onClick={() =>
          showModal({
            title: `View detailed adjustments (App. ID ${applicationId})`,
            content: (
              <AdjustmentDetailsModal
                groupedData={groupedData}
                applicationId={applicationId}
                transferInBU = {transferInBU}
                transferOutBU = {transferOutBU}
              />
            ),
            maxWidth: "lg",
          })
        }
      >
        View detailed adjustments
      </span>
    </div>
  );
};

export default ViewAdjustmentsButton;
